import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="inversion" className="w-full bg-white py-16 md:py-24" data-id="element-108" data-mp="2jknqblhfrnqr">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-109" data-mp="1vts18w4d76n7">
        {showUrgency && <CountdownPanel headline="L’offre de lancement se termine dans :" subtext={`Le kit reviendra ensuite à son prix habituel de ${offer.listPrice}.`} data-id="element-110" data-mp="1rsgdkw51wvhn" />}

        <h2 className="mt-16 text-center text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-111" data-mp="20teh7dbkv0zp">
          Votre tarif aujourd’hui
        </h2>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-stone-50 p-7 text-center shadow-xl ring-1 ring-neutral-200 md:p-12" data-id="element-112" data-mp="3h9hczoy9bdzl">
          <p className="text-lg text-neutral-500" data-id="element-113" data-mp="3vzylsdwtf31i">
            Prix habituel : <span className="line-through" data-id="element-114" data-mp="3w1jk8em9364n">{offer.listPrice}</span>
          </p>

          <p className="mt-4 text-sm font-extrabold uppercase tracking-widest text-pink-700" data-id="element-115" data-mp="4rb01wunxdtf">
            Aujourd’hui
          </p>
          <p className="mt-2 text-6xl font-extrabold leading-none tracking-tight text-pink-900 md:text-7xl" data-id="element-116" data-mp="erblboc3e409">
            {`${offer.price}\u00A0${offer.currency}`}
          </p>

          <p className="mt-5 inline-block rounded-lg bg-pink-200 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-pink-950" data-id="element-117" data-mp="3d6uq6n01eg49">
            {offer.subtitle}
          </p>

          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-neutral-500" data-id="element-118" data-mp="3n5k5q94gnohc">
            {offer.detail}
          </p>

          <div className="mt-9" data-id="element-119" data-mp="2uihd1xmgu7z0">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-120" data-mp="2uj97v688o1o8">
              {offer.cta}
            </CtaButton>
          </div>
        </div>

        <TrustIcons className="mt-10" data-id="element-121" data-mp="2zfg4g8eqw0ti" />
      </div>
    </section>;
}